/*
  a11y-fixes-2.js  (accessibility remediation epic, round 2; v10 2026-10-26)
  Second small accessibility layer, loaded after a11y-fixes.js. Kept separate so later fixes only
  touch this small file. Remove this file + its <script> tag in layout/theme.liquid to roll back.
  Version check: browser console shows "[a11y-fixes-2] v10 loaded".

  C. Quick view (SHO-1010): dialog named "Quick view, <product>", aria-modal while open, "Close quick view"
     on all close buttons, "Previous image"/"Next image" arrows, opener buttons include the product name,
     focus returns to the opener on close followed by "Quick view closed".
  <product-card> cards: buttons include the product name, duplicate picture link removed from Tab order,
     card wrapper role=none.
  D. Main menu, desktop (SHO-1003, SHO-1004): submenu links named after their page (were "Visit " in a
     "Link preview card" group); Tab on top items no longer opens submenus; "Show <item> menu" buttons
     (visible on keyboard focus) open a submenu; Escape / Shift+Tab / Tab past the end close it.
     Key handling runs on window (capture) before the theme's dropdown key handler.
  D2. Mobile menu (hamburger, <drawer-menu id="DrawerMenu">):
     - Hamburger button: aria-expanded + aria-controls; named "Close menu" while open.
     - Panel: dialog named "Menu", aria-modal while open; focus moves into it when it opens.
     - Indoor Gardens / Plant Pods / Accessories (drawer-menu-page-link): buttons that announce a submenu;
       Space works like Enter.
     - Back arrow on submenu pages (was tabindex=-1, unreachable): button "Back to main menu";
       after going back, focus returns to the item that opened the submenu.
     - While a submenu page is shown, the main menu page behind it (and hidden pages) are inert.
       (v10) Focus moves to the submenu page's "Back to main menu" button when the page opens
       (it was lost because the main page became inert while it had focus).
     - Escape: back one level from a submenu page; closes the menu from the main page.
  Header extras: logo "Click & Grow, home"; region buttons "Region: US ($)" (desktop and mobile).
*/
(function () {
  'use strict';

  var VERSION = 'v10';
  window.A11Y_FIXES2_VERSION = VERSION;
  try { console.info('[a11y-fixes-2] ' + VERSION + ' loaded'); } catch (e) { /* ignore */ }

  function txt(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function visibleText(el) {
    return el ? (el.innerText || '').replace(/\s+/g, ' ').trim() : '';
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }

  function isTabbable(el) {
    return isVisible(el) && el.tabIndex >= 0 && !el.disabled &&
      !el.closest('[inert], [aria-hidden="true"]');
  }

  function focusIsLost() {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement;
  }

  // Uses the live region created by a11y-fixes.js (creates one if missing).
  function announce(msg) {
    var el = document.getElementById('A11yLiveRegion');
    if (!el) {
      el = document.createElement('div');
      el.id = 'A11yLiveRegion';
      el.className = 'visually-hidden';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    el.textContent = '';
    setTimeout(function () { el.textContent = msg; }, 150);
  }

  /* ---------- Product name for a card control ---------- */
  var CARD_SEL = 'product-card, vertical-product-card, horizontal-product-card';
  var TITLE_SEL = '[class*="__title"], [class*="card-title"], [class*="product-title"]';

  function productNameFor(el) {
    var card = el.closest(CARD_SEL) || el.closest('li, .shop__grid-item');
    if (card) {
      var title = card.querySelector(TITLE_SEL);
      if (title && txt(title)) return txt(title);
      var links = card.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) if (visibleText(links[i])) return visibleText(links[i]);
    }
    return '';
  }

  function addProductName(b) {
    var current = b.getAttribute('aria-label') || visibleText(b);
    if (!current || current.indexOf(',') !== -1) return; // empty, or already includes the product name
    var name = productNameFor(b);
    if (name) b.setAttribute('aria-label', current + ', ' + name);
  }

  function labelQuickViewButtons() {
    var btns = document.querySelectorAll('[data-quick-view-button]');
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].getAttribute('aria-label') && !visibleText(btns[i])) btns[i].setAttribute('aria-label', 'Quick view');
      addProductName(btns[i]);
    }
  }

  /* ---------- <product-card> cards ---------- */
  function hrefKey(a) {
    return (a.getAttribute('href') || '').split('?')[0].split('#')[0];
  }

  function fixProductCards() {
    var cards = document.querySelectorAll('product-card');
    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      if (card.getAttribute('role') !== 'none' && !card.hasAttribute('tabindex')) card.setAttribute('role', 'none');

      var btns = card.querySelectorAll('button, [role="button"]');
      for (var b = 0; b < btns.length; b++) addProductName(btns[b]);

      var links = card.querySelectorAll('a[href]');
      var textHrefs = {};
      for (var i = 0; i < links.length; i++) {
        if (visibleText(links[i])) textHrefs[hrefKey(links[i])] = true;
      }
      for (var j = 0; j < links.length; j++) {
        var l = links[j];
        if (!visibleText(l) && textHrefs[hrefKey(l)]) {
          if (l.getAttribute('tabindex') !== '-1') l.setAttribute('tabindex', '-1');
          if (l.getAttribute('aria-hidden') !== 'true') l.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }

  /* ---------- Quick view dialog ---------- */
  function quickView() {
    return document.getElementById('Quick-view');
  }

  function quickViewIsOpen(d) {
    var closes = d.querySelectorAll('.quick-view__close-button');
    for (var i = 0; i < closes.length; i++) if (closes[i].classList.contains('is-opened')) return true;
    if (closes.length) return false;
    return d.contains(document.activeElement);
  }

  function fixQuickView() {
    var d = quickView();
    if (!d) return;
    if (d.getAttribute('role') !== 'dialog') d.setAttribute('role', 'dialog');

    var heading = d.querySelector('h1, h2, h3, h4, h5, h6, [class*="__title"]');
    var name = 'Quick view' + (heading && txt(heading) ? ', ' + txt(heading) : '');
    if (d.getAttribute('aria-label') !== name) d.setAttribute('aria-label', name);

    var open = quickViewIsOpen(d);
    if (open && d.getAttribute('aria-modal') !== 'true') d.setAttribute('aria-modal', 'true');
    if (!open && d.hasAttribute('aria-modal')) d.removeAttribute('aria-modal');

    var closes = d.querySelectorAll('.quick-view__close-button');
    for (var c = 0; c < closes.length; c++) {
      var close = closes[c];
      if (close.getAttribute('aria-label') !== 'Close quick view') close.setAttribute('aria-label', 'Close quick view');
      var svgs = close.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) svgs[i].setAttribute('aria-hidden', 'true');
      var wrapper = close.closest('sidebar-button');
      if (wrapper && wrapper.getAttribute('role') !== 'none') wrapper.setAttribute('role', 'none');
    }

    var arrows = d.querySelectorAll('[data-direction]');
    for (var a = 0; a < arrows.length; a++) {
      var label = arrows[a].getAttribute('data-direction') === 'prev' ? 'Previous image' : 'Next image';
      if (arrows[a].getAttribute('aria-label') !== label) arrows[a].setAttribute('aria-label', label);
    }

    var aside = d.closest('aside');
    if (aside && aside.getAttribute('role') !== 'none') aside.setAttribute('role', 'none');
  }

  /* ---------- Return focus to the opener when the quick view closes ---------- */
  var opener = null;

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-quick-view-button]');
    if (b) opener = b;
  }, true);

  function returnFocusIfClosed() {
    var d = quickView();
    if (!d || !opener) return;
    if (quickViewIsOpen(d)) return;
    if (!focusIsLost() && !d.contains(document.activeElement)) return;
    if (document.contains(opener)) opener.focus();
    opener = null;
    announce('Quick view closed');
  }

  document.addEventListener('focusout', function (e) {
    var d = quickView();
    if (d && d.contains(e.target)) {
      setTimeout(returnFocusIfClosed, 350);
      setTimeout(returnFocusIfClosed, 900);
    }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      setTimeout(returnFocusIfClosed, 350);
      setTimeout(returnFocusIfClosed, 900);
    }
  }, true);

  /* ---------- D. Main menu (desktop) ---------- */
  var TOGGLE_CLASS = 'a11y-submenu-toggle';
  var menuOpenedByToggle = null;   // the toggle button whose submenu is open (keyboard)
  var lastKeyWasTab = false;
  var lastFocusWasInMenu = false;

  function dropdown() {
    return document.getElementById('HeaderDropdownMenu');
  }

  // Links/buttons in the open submenu that are really reachable with Tab, in DOM order.
  function dropdownLinks() {
    var dd = dropdown();
    if (!dd) return [];
    return Array.prototype.filter.call(dd.querySelectorAll('a[href], button'), isTabbable);
  }

  // The theme's isOpen flag lags behind its closing animation; trust what is visible.
  function dropdownIsOpen() {
    var dd = dropdown();
    if (!dd) return false;
    return Array.prototype.some.call(dd.querySelectorAll('a[href]'), isVisible);
  }

  function hideDropdown() {
    var dd = dropdown();
    if (dd && typeof dd.hide === 'function' && (dd.isOpen || dropdownIsOpen())) {
      try { dd.hide(); } catch (e) { /* ignore */ }
    }
  }

  function injectToggleStyles() {
    if (document.getElementById('A11yMenuStyles')) return;
    var s = document.createElement('style');
    s.id = 'A11yMenuStyles';
    s.textContent =
      '.' + TOGGLE_CLASS + '{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;' +
      'clip:rect(0 0 0 0);white-space:nowrap;border:0;}' +
      '.' + TOGGLE_CLASS + ':focus{position:absolute;top:100%;left:0;width:auto;height:auto;margin:0;' +
      'padding:4px 10px;overflow:visible;clip:auto;z-index:1000;background:#fff;color:#1a1a1a;' +
      'border:2px solid #1a1a1a;border-radius:4px;font-size:13px;line-height:1.3;}' +
      '.a11y-submenu-host{position:relative;}';
    document.head.appendChild(s);
  }

  function topLinkOf(wrapper) {
    return wrapper.querySelector('a[href], button');
  }

  function setupMenuToggles() {
    var wrappers = document.querySelectorAll('header header-float-element-btn');
    if (!wrappers.length) return;
    injectToggleStyles();
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      var top = topLinkOf(w);
      if (!top) continue;
      var name = top.getAttribute('aria-label') || visibleText(top);
      var toggle = w.nextElementSibling;
      if (!toggle || !toggle.classList.contains(TOGGLE_CLASS)) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = TOGGLE_CLASS;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', 'HeaderDropdownMenu');
        toggle.textContent = 'Show ' + name + ' menu';
        toggle.__wrapper = w;
        w.insertAdjacentElement('afterend', toggle);
        if (w.parentElement && getComputedStyle(w.parentElement).position === 'static') {
          w.parentElement.classList.add('a11y-submenu-host');
        }
        toggle.addEventListener('click', onToggleClick);
      }
      // Hide the toggle when its top item is not shown (e.g. mobile layout)
      var shown = isVisible(top);
      if (toggle.hidden === shown) toggle.hidden = !shown;
      var expanded = (menuOpenedByToggle === toggle && dropdownIsOpen()) ? 'true' : 'false';
      if (toggle.getAttribute('aria-expanded') !== expanded) toggle.setAttribute('aria-expanded', expanded);
    }
  }

  function openFromToggle(toggle) {
    var w = toggle.__wrapper;
    if (!w) return;
    hideDropdown();
    menuOpenedByToggle = toggle;
    setTimeout(function () {
      w.dispatchEvent(new MouseEvent('mouseenter'));
      var tries = 0;
      (function waitForLinks() {
        var links = dropdownLinks();
        if (links.length) {
          fixMenuLinks();
          toggle.setAttribute('aria-expanded', 'true');
          links[0].focus();
        } else if (++tries < 20) {
          setTimeout(waitForLinks, 75);
        }
      })();
    }, 60);
  }

  function closeToToggle(focusTarget) {
    var toggle = menuOpenedByToggle;
    hideDropdown();
    menuOpenedByToggle = null;
    lastFocusWasInMenu = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var target = focusTarget || toggle;
    if (target) target.focus();
  }

  function onToggleClick(e) {
    var toggle = e.currentTarget;
    if (menuOpenedByToggle === toggle && dropdownIsOpen()) closeToToggle(toggle);
    else openFromToggle(toggle);
  }

  // Next focusable element in the header after the given element (skipping hidden ones).
  function nextHeaderFocusable(after) {
    var header = document.querySelector('header');
    var dd = dropdown();
    if (!header) return null;
    var all = Array.prototype.filter.call(
      header.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        if (el.hidden || (dd && dd.contains(el))) return false;
        return el.classList.contains(TOGGLE_CLASS) || isVisible(el);
      }
    );
    var idx = all.indexOf(after);
    return idx >= 0 ? all[idx + 1] || null : null;
  }

  function stopAll(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  /* ---------- D2. Mobile menu (drawer) ---------- */
  var lastDrawerItem = null;   // drawer item that opened the current submenu page
  var drawerWasOpen = false;
  var lastSubPageId = null;

  function drawer() {
    return document.getElementById('DrawerMenu');
  }

  function drawerToggler() {
    return document.getElementById('DrawerMenuToggler');
  }

  function drawerIsOpen() {
    var d = drawer();
    return !!(d && d.classList.contains('is-opened'));
  }

  function openSubPage() {
    var d = drawer();
    if (!d) return null;
    var pages = d.querySelectorAll('drawer-menu-page');
    for (var i = 0; i < pages.length; i++) {
      if (pages[i].getAttribute('data-page-id') !== 'Menu' && pages[i].getAttribute('aria-hidden') === 'false') return pages[i];
    }
    return null;
  }

  function firstTabbableIn(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'), isTabbable)[0] || null;
  }

  function fixDrawerMenu() {
    var d = drawer();
    if (!d) return;
    var open = drawerIsOpen();

    var tog = drawerToggler();
    if (tog) {
      var exp = open ? 'true' : 'false';
      if (tog.getAttribute('aria-expanded') !== exp) tog.setAttribute('aria-expanded', exp);
      if (tog.getAttribute('aria-controls') !== 'DrawerMenu') tog.setAttribute('aria-controls', 'DrawerMenu');
      var label = open ? 'Close menu' : 'Menu';
      if (tog.getAttribute('aria-label') !== label) tog.setAttribute('aria-label', label);
    }

    if (d.getAttribute('role') !== 'dialog') d.setAttribute('role', 'dialog');
    if (d.getAttribute('aria-label') !== 'Menu') d.setAttribute('aria-label', 'Menu');
    if (open && d.getAttribute('aria-modal') !== 'true') d.setAttribute('aria-modal', 'true');
    if (!open && d.hasAttribute('aria-modal')) d.removeAttribute('aria-modal');

    // Page links: forward items and back arrows
    var links = d.querySelectorAll('drawer-menu-page-link');
    for (var i = 0; i < links.length; i++) {
      var l = links[i];
      var target = l.getAttribute('data-page-id');
      if (l.getAttribute('role') !== 'button') l.setAttribute('role', 'button');
      var svgs = l.querySelectorAll('svg');
      for (var s = 0; s < svgs.length; s++) svgs[s].setAttribute('aria-hidden', 'true');
      if (target === 'Menu') {
        if (l.getAttribute('tabindex') !== '0') l.setAttribute('tabindex', '0');
        if (l.getAttribute('aria-label') !== 'Back to main menu') l.setAttribute('aria-label', 'Back to main menu');
      } else {
        var title = l.getAttribute('menu-title') || visibleText(l);
        if (title && l.getAttribute('aria-label') !== title) l.setAttribute('aria-label', title);
        if (l.getAttribute('aria-haspopup') !== 'true') l.setAttribute('aria-haspopup', 'true');
      }
    }

    // Pages: hidden pages inert; the main page inert while a submenu page is shown.
    var sub = openSubPage();
    var root = d.querySelector('drawer-menu-page[data-page-id="Menu"]');
    var focusWasInRoot = root && root.contains(document.activeElement);
    var pages = d.querySelectorAll('drawer-menu-page');
    for (var p = 0; p < pages.length; p++) {
      var pg = pages[p];
      var isRoot = pg.getAttribute('data-page-id') === 'Menu';
      var shouldBeInert = isRoot ? !!sub : pg.getAttribute('aria-hidden') === 'true';
      if (shouldBeInert && !pg.hasAttribute('inert')) pg.setAttribute('inert', '');
      if (!shouldBeInert && pg.hasAttribute('inert')) pg.removeAttribute('inert');
    }

    // A submenu page just opened: put focus on its first control ("Back to main menu").
    var subId = sub ? sub.getAttribute('data-page-id') : null;
    if (open && sub && subId !== lastSubPageId && (focusWasInRoot || focusIsLost() || !d.contains(document.activeElement))) {
      var firstSub = firstTabbableIn(sub);
      if (firstSub) setTimeout(function () { firstSub.focus(); }, 50);
    }
    // Back on the main page with focus lost: return to the item that opened the submenu.
    if (open && !sub && lastSubPageId && focusIsLost()) {
      var item = lastDrawerItem && document.contains(lastDrawerItem) ? lastDrawerItem : (root && firstTabbableIn(root));
      if (item) setTimeout(function () { item.focus(); }, 50);
    }
    lastSubPageId = open ? subId : null;

    // Focus into the panel when it opens.
    if (open && !drawerWasOpen) {
      setTimeout(function () {
        if (!drawerIsOpen()) return;
        var dd = drawer();
        if (dd.contains(document.activeElement)) return;
        var first = firstTabbableIn(dd);
        if (first) first.focus();
      }, 350);
    }
    drawerWasOpen = open;
  }

  // Remember which drawer item opened a submenu; after "Back", return focus there.
  document.addEventListener('click', function (e) {
    var l = e.target && e.target.closest && e.target.closest('#DrawerMenu drawer-menu-page-link');
    if (!l) return;
    if (l.getAttribute('data-page-id') === 'Menu') {
      var item = lastDrawerItem;
      setTimeout(function () { fixDrawerMenu(); if (item && document.contains(item)) item.focus(); }, 450);
    } else {
      lastDrawerItem = l;
      setTimeout(fixDrawerMenu, 450);
    }
  }, true);

  function drawerGoBack() {
    var sub = openSubPage();
    if (!sub) return false;
    var back = sub.querySelector('drawer-menu-page-link[data-page-id="Menu"]');
    if (back) { back.click(); return true; }
    return false;
  }

  // Registered on window (capture) at load, i.e. before the theme's own key handlers.
  window.addEventListener('keydown', function (e) {
    lastKeyWasTab = (e.key === 'Tab');
    var t = e.target;

    // ---- Mobile drawer ----
    var d = drawer();
    if (d && drawerIsOpen() && t && t.closest && (d.contains(t) || t === drawerToggler())) {
      if ((e.key === ' ' || e.key === 'Spacebar') && t.matches && t.matches('drawer-menu-page-link')) {
        stopAll(e);
        if (t.getAttribute('data-page-id') !== 'Menu') lastDrawerItem = t;
        t.click();
        return;
      }
      if (e.key === 'Enter' && t.matches && t.matches('drawer-menu-page-link')) {
        if (t.getAttribute('data-page-id') === 'Menu') { stopAll(e); t.click(); return; }
        lastDrawerItem = t;
      }
      if (e.key === 'Escape') {
        stopAll(e);
        if (!drawerGoBack()) {
          var tog = drawerToggler();
          if (tog) { tog.click(); setTimeout(function () { tog.focus(); fixDrawerMenu(); }, 350); }
        }
        return;
      }
    }

    // ---- Desktop menu ----
    // Tab on a top menu item: let the browser move focus, but don't let the theme see it
    // (the theme would open the submenu and keep focus on the item).
    if (e.key === 'Tab' && !menuOpenedByToggle && t && t.closest && t.closest('header-float-element-btn')) {
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }

    if (!menuOpenedByToggle || !dropdownIsOpen()) return;
    var dd = dropdown();
    var inMenu = dd.contains(t);
    if (e.key === 'Escape' && (inMenu || t === menuOpenedByToggle)) {
      stopAll(e);
      closeToToggle();
      return;
    }
    if (e.key === 'Tab' && inMenu) {
      var links = dropdownLinks();
      var first = links[0], last = links[links.length - 1];
      if (!e.shiftKey && t === last) {
        stopAll(e);
        closeToToggle(nextHeaderFocusable(menuOpenedByToggle) || menuOpenedByToggle);
      } else if (e.shiftKey && t === first) {
        stopAll(e);
        closeToToggle();
      } else {
        // Normal Tab inside the submenu: let the browser move focus, keep the theme out of it.
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Safety net: a submenu opened while a top item has keyboard focus (not via the toggle) is closed again.
    var w = t.closest('header-float-element-btn');
    if (w && lastKeyWasTab) {
      [30, 150, 400, 800].forEach(function (ms) {
        setTimeout(function () {
          if (!menuOpenedByToggle && dropdownIsOpen() && document.activeElement === t) hideDropdown();
        }, ms);
      });
    }

    if (!menuOpenedByToggle) { lastFocusWasInMenu = false; return; }
    var dd = dropdown();
    if (dd && dd.contains(t)) { lastFocusWasInMenu = true; return; }
    if (t === menuOpenedByToggle) { lastFocusWasInMenu = false; return; }

    // Focus left the open submenu.
    var header = document.querySelector('header');
    var leftForwardIntoPage = lastFocusWasInMenu && lastKeyWasTab && header && !header.contains(t);
    var toggle = menuOpenedByToggle;
    hideDropdown();
    toggle.setAttribute('aria-expanded', 'false');
    menuOpenedByToggle = null;
    lastFocusWasInMenu = false;
    if (leftForwardIntoPage) {
      var next = nextHeaderFocusable(toggle);
      if (next) setTimeout(function () { next.focus(); }, 0);
    }
  }, true);

  // Submenu links (desktop dropdown and mobile drawer) were named "Visit " inside "Link preview card" groups.
  function fixMenuLinks() {
    var groups = document.querySelectorAll('[aria-label="Link preview card"]');
    for (var g = 0; g < groups.length; g++) {
      groups[g].removeAttribute('aria-label');
      groups[g].setAttribute('role', 'none');
    }
    var links = document.querySelectorAll('a.header-menu__cg-link__url');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var current = (a.getAttribute('aria-label') || '').trim();
      if (current && current !== 'Visit') continue;
      var name = visibleText(a) || txt(a);
      name = name.replace(/^Go to\s+/i, '').trim();
      if (!name) {
        var img = a.querySelector('img[alt]');
        name = img ? img.getAttribute('alt') : '';
      }
      if (name) {
        a.setAttribute('aria-label', name);
        if (a.getAttribute('role') === 'link') a.removeAttribute('role');
      }
    }
  }

  function fixHeaderExtras() {
    var logos = document.querySelectorAll('header a.header__logo[aria-label="Logo"]');
    for (var i = 0; i < logos.length; i++) logos[i].setAttribute('aria-label', 'Click & Grow, home');
    var regions = document.querySelectorAll('[aria-label="RegionSelector"]');
    for (var r = 0; r < regions.length; r++) {
      var t = visibleText(regions[r]);
      regions[r].setAttribute('aria-label', 'Region: ' + (t || 'select region'));
    }
  }

  /* ---------- Run on load and whenever the page changes ---------- */
  var scheduled = false;
  function runFixes() {
    scheduled = false;
    try {
      labelQuickViewButtons();
      fixProductCards();
      fixQuickView();
      fixMenuLinks();
      setupMenuToggles();
      fixDrawerMenu();
      fixHeaderExtras();
    } catch (err) { /* never break the page */ }
  }

  var observer = new MutationObserver(function () {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(runFixes);
    }
  });

  var attrObserver = new MutationObserver(function (records) {
    var qv = false, dr = false;
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      if (t.classList && t.classList.contains('quick-view__close-button')) qv = true;
      if (t.id === 'DrawerMenu' || (t.tagName && t.tagName.toLowerCase() === 'drawer-menu-page')) dr = true;
    }
    try { if (qv) fixQuickView(); if (dr) fixDrawerMenu(); } catch (err) { /* ignore */ }
  });

  function init() {
    runFixes();
    observer.observe(document.body, { childList: true, subtree: true });
    attrObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden'] });
    window.addEventListener('resize', function () { try { setupMenuToggles(); } catch (e) { /* ignore */ } });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
